import { CloseWrapper, Container, Content, Page } from "./style";
import Icon from '../Icon';
import CrossIcon from '../../Assets/icons/K2.svg';
import { useRef } from "react";
import { useClickedOutside } from "../../Hooks/useClickedOutside";
import ReactDOM from 'react-dom';

const Modal = ({isOpen, handleClose, children }) => {

    const modalRef = useRef(null);
    const modal = document.getElementById('modal-root');

    useClickedOutside(modalRef, handleClose, isOpen);

    const initModal = () => {
        return (
        <Container>
            <Page >
                <Icon classes = "cursor-click" onclick={handleClose} src = {CrossIcon} alt = "close icon"/>
                <Content ref = {modalRef}>
                    {children}
                </Content>
            </Page>
        </Container>
    );

    }

    if(!isOpen) {
        return (<></>);
    }
    /*
    return (
        <Container>
            <Page >
                <Icon classes = "cursor-click" onclick={handleClose} src = {CrossIcon} alt = "close icon"/>
                <Content ref = {modalRef}>
                    {children}
                </Content>
            </Page>
        </Container>
    );
    */
    return (
        ReactDOM.createPortal(initModal(), modal)
    );

};

export default Modal;